module.exports = __webpack_public_path__ + "static/media/aeps_report.01697689.svg";